import { Grid, Typography } from '@mui/material'
import clsx from 'clsx'
import Image from 'next/image'
import React from 'react'
import { ButtonComponent } from 'src/components/shared/atoms'
import useStyles from './Style'
import { ammbasadorCardsI } from 'src/types/store/index'
import { useRouter } from 'next/router'
interface IProps {
  zenMode: boolean
  content: ammbasadorCardsI
}
const Card: React.FC<IProps> = ({ zenMode, content }) => {
  const { image, heading, description, button } = content
  const router = useRouter()
  const { classes } = useStyles()
  return (
    <Grid
      className={clsx(
        classes.rootContainer,
        zenMode && classes.zenRootContainer
      )}
    >
      {!zenMode && (
        <Grid className={classes.imgContainer}>
          <Image
            alt={heading}
            src={`${image.data.attributes.url}`}
            height="117"
            width="117"
          />
        </Grid>
      )}
      <Typography
        className={`${classes.heading} ${zenMode && classes.zenColor}`}
      >
        {heading}
      </Typography>
      <Typography className={`${classes.text} ${zenMode && classes.zenColor}`}>
        {description}
      </Typography>
      <Grid>
        <ButtonComponent
          className={classes.btn}
          text={button.content}
          type="text"
          gradient
          onClick={() => (button.href ? router.push(button.href) : '')}
        />
      </Grid>
    </Grid>
  )
}

export default Card
